import { apiFetch } from './client';

export async function getAllSettings() {
  return await apiFetch('/admin/settings');
}

export async function setSetting(key, value, description = null) {
  return await apiFetch('/admin/settings', {
    method: 'POST',
    body: JSON.stringify({ key, value, description }),
  });
}

export async function deleteSetting(key) {
  return await apiFetch(`/admin/settings/${encodeURIComponent(key)}`, { method: 'DELETE' });
}

export async function getAdminDashboard() {
  return await apiFetch('/admin/dashboard');
}

export async function getAdminBadges() {
  return await apiFetch('/admin/badges');
}

